import React from 'react';

import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import FormatColorTextIcon from '@material-ui/icons/FormatColorText';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import PaletteIcon from '@material-ui/icons/Palette';
import PhotoSizeSelectLargeIcon from '@material-ui/icons/PhotoSizeSelectLarge';
import ToysIcon from '@material-ui/icons/Toys';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';

import mixpanel from '../mixpanel';

const LinkList = () => {
  return (
    <div className="row flex-center mt1">
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://generator.sharethrough.com"
          title="Native Ad Generator"
          target="_blank"
          onClick={() => mixpanel.track('NAG Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle blueberry">
                <ImportantDevicesIcon className="material-icons" />
              </div>
              <h5>NAG</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://planning.sharethrough.com/deals"
          title="Media Planning - Deals"
          target="_blank"
          onClick={() => mixpanel.track('Deals Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle oceanblue">
                <CollectionsBookmarkIcon className="material-icons" />
              </div>
              <h5>Media Planning Tool</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://sam.sharethrough.com"
          title="SAM"
          target="_blank"
          onClick={() => mixpanel.track('SAM Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle blueberry-dark">
                <svg
                  className="logo-sam"
                  width="26px"
                  height="30px"
                  viewBox="0 0 26 30"
                  version="1.1"
                >
                  <g
                    id="WF"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g id="Artboard" fill="#ffffff">
                      <path
                        d="M24.5556,21.7428 L13.7016,28.0218 L13.7016,15.4628 L24.5556,9.1828 L24.5556,21.7428 Z M1.4446,20.9038 L1.4446,10.5548 L5.8936,18.3288 L1.4446,20.9038 Z M12.7536,1.7138 L18.1436,11.1308 L7.0976,17.5228 L1.7066,8.1048 L12.7536,1.7138 Z M25.9986,7.9298 C25.9986,7.6708 25.8626,7.4318 25.6386,7.3028 C25.4146,7.1738 25.1386,7.1738 24.9156,7.3028 L19.4336,10.4748 L13.6466,0.3638 C13.6306,0.3368 13.6046,0.3188 13.5856,0.2948 C13.5566,0.2558 13.5276,0.2168 13.4916,0.1848 C13.4566,0.1558 13.4196,0.1338 13.3806,0.1108 C13.3396,0.0868 13.2976,0.0628 13.2516,0.0468 C13.2366,0.0418 13.2236,0.0298 13.2066,0.0248 C13.1756,0.0158 13.1436,0.0228 13.1106,0.0178 C13.0796,0.0138 13.0516,-0.0002 13.0196,-0.0002 C13.0036,-0.0002 12.9906,0.0088 12.9736,0.0098 C12.9246,0.0128 12.8796,0.0248 12.8326,0.0378 C12.7876,0.0508 12.7426,0.0618 12.7016,0.0828 C12.6876,0.0898 12.6716,0.0898 12.6596,0.0968 L0.4486,7.1618 L0.4146,7.1808 L0.3616,7.2118 C0.3426,7.2218 0.3326,7.2398 0.3166,7.2518 C0.2826,7.2768 0.2436,7.2948 0.2136,7.3258 C0.2016,7.3368 0.1976,7.3538 0.1856,7.3668 C0.1526,7.4048 0.1276,7.4458 0.1036,7.4898 C0.0816,7.5278 0.0606,7.5648 0.0466,7.6068 C0.0306,7.6538 0.0246,7.7008 0.0176,7.7498 C0.0136,7.7798 -0.0004,7.8078 -0.0004,7.8388 L-0.0004,22.1578 C-0.0004,22.4158 0.1376,22.6558 0.3616,22.7848 C0.4726,22.8488 0.5976,22.8818 0.7226,22.8818 C0.8466,22.8818 0.9716,22.8488 1.0826,22.7848 L12.2576,16.3188 L12.2576,29.2758 C12.2576,29.5348 12.3956,29.7738 12.6186,29.9038 C12.7306,29.9678 12.8556,29.9998 12.9806,29.9998 C13.1056,29.9998 13.2306,29.9678 13.3416,29.9038 L25.6386,22.7868 C25.8626,22.6578 25.9996,22.4188 25.9996,22.1598 L25.9986,7.9298 Z"
                        id="Fill-1"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <h5>SAM</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="http://generator.sharethrough.com/partners"
          title="Custom NAGs"
          target="_blank"
          onClick={() => mixpanel.track('Custom NAGs Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle wine">
                <PaletteIcon className="material-icons" />
              </div>
              <h5>Custom NAGs</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://gallery.sharethrough.com"
          title="Native Gallery"
          target="_blank"
          onClick={() => mixpanel.track('Native Gallery Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle mint-dark">
                <ViewCarouselIcon className="material-icons" />
              </div>
              <h5>Native Gallery</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://headlines.sharethrough.com"
          title="Headline Analyzer"
          target="_blank"
          onClick={() => mixpanel.track('Headline Analyzer Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle peach">
                <FormatColorTextIcon className="material-icons" />
              </div>
              <h5>Headline Analyzer</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://generator.sharethrough.com/thumbnails/new"
          title="Image Resizer"
          target="_blank"
          onClick={() => mixpanel.track('Image Resizer Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle banana">
                <PhotoSizeSelectLargeIcon className="material-icons" />
              </div>
              <h5>Image Resizer</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://askstr.zendesk.com/hc/en-us/categories/115001818368-Research"
          title="Native Research Materials"
          target="_blank"
          onClick={() => mixpanel.track('Native Research Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle punica">
                <ToysIcon className="material-icons" />
              </div>
              <h5>Native Research</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://askstr.zendesk.com/hc/en-us/categories/115002272887-SFA-Sales-Portal"
          title="ASK - Sales"
          target="_blank"
          onClick={() => mixpanel.track('ASK - Sales Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle knight-light">
                <HelpOutlineIcon className="material-icons" />
              </div>
              <h5>ASK - Sales</h5>
            </div>
          </div>
        </a>
      </div>
      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="https://chrome.google.com/webstore/detail/paparazzi/idklganmlgnaikfegnpmbabgpmickbhe"
          title="Paparazzi"
          target="_blank"
          onClick={() => mixpanel.track('Paparazzi Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle blueberry">
                <svg
                  className="logo-paparazzi"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <g
                    id="Site"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g id="svg-paparazzi" fill="#FFFFFF">
                      <path
                        d="M27.8915089,7.87366106 C28.0361637,7.89712051 28.0361637,8.1043457 27.8915089,8.12780516 C23.6144166,8.8276789 22.8266341,9.61357064 22.1287721,13.8929662 C22.1033598,14.0356779 21.8981063,14.0356779 21.872694,13.8929662 C21.1728772,9.61357064 20.3850947,8.8276789 16.1099572,8.12780516 C15.9633476,8.1043457 15.9633476,7.89712051 16.1099572,7.87366106 C20.3850947,7.17378732 21.1728772,6.38594062 21.872694,2.10849998 C21.8981063,1.96383334 22.1033598,1.96383334 22.1287721,2.10849998 C22.8266341,6.38594062 23.6144166,7.17378732 27.8915089,7.87366106 Z M29.9852952,12.1193443 C28.5088675,14.1759948 28.5088675,14.8247625 29.9852952,16.8795105 C30.0347631,16.9499047 29.9491455,17.0336166 29.8806514,16.986053 C27.8239268,15.507776 27.1751358,15.507776 25.1184111,16.986053 C25.049917,17.0336166 24.9642995,16.9499047 25.01567,16.8795105 C26.4940003,14.8247625 26.4940003,14.1759948 25.01567,12.1193443 C24.9642995,12.0508527 25.049917,11.9652382 25.1184111,12.0147043 C27.1751358,13.4929814 27.8239268,13.4929814 29.8806514,12.0147043 C29.9491455,11.9652382 30.0347631,12.0508527 29.9852952,12.1193443 Z M14.1212119,4.98529792 C14.0508282,5.03475659 13.9652264,4.94915505 14.0146852,4.88067382 C15.4927434,2.82433471 15.4927434,2.17566529 14.0146852,0.119326179 C13.9652264,0.0508449502 14.0508282,-0.0347565855 14.1212119,0.0147020795 C16.1737535,1.49275526 16.8262296,1.49275526 18.8806734,0.0147020795 C18.9491549,-0.0347565855 19.0347567,0.0508449502 18.9852979,0.119326179 C17.5072397,2.17566529 17.5072397,2.82433471 18.9852979,4.88067382 C19.0347567,4.94915505 18.9491549,5.03475659 18.8806734,4.98529792 C16.8262296,3.50724474 16.1737535,3.50724474 14.1212119,4.98529792 Z M11,15 C13.078922,15 14.7959577,16.5834137 14.9826756,18.6142719 C15,18.7338476 15,18.8707811 15,19.0096432 C15,19.2160077 14.9826756,19.4204436 14.9499519,19.611379 C14.6573628,21.5380906 12.9923003,23 11,23 C9.00962464,23 7.34456208,21.5380906 7.05197305,19.611379 C7.01732435,19.4204436 7,19.2160077 7,19.0096432 C7,18.8707811 7.01732435,18.7338476 7.01732435,18.6142719 C7.22329163,16.5834137 8.92300289,15 11,15 Z M21.2018658,15.8780446 C21.6427399,15.8780446 22,16.2333736 22,16.6742097 L22,27.2903783 C22,28.7858007 20.7856958,30 19.2901443,30 L2.70985575,30 C1.2124039,30 0,28.7858007 0,27.2903783 L0,10.7115219 C0,9.21419934 1.2124039,8 2.70985575,8 L13.4504621,8 C13.6689989,8 13.8704328,8.09120746 14.0129567,8.23371912 C14.157381,8.38003109 14.246696,8.57764726 14.246696,8.7980653 C14.246696,9.23890136 13.889436,9.59423044 13.4504621,9.59423044 L2.70985575,9.59423044 C2.09225188,9.59423044 1.59436814,10.0939713 1.59436814,10.7115219 L1.59436814,18.2038349 L4.9161268,18.2038349 C4.88002073,18.4641562 4.86101753,18.7301779 4.86101753,19 C4.86101753,19.2698221 4.88002073,19.5358438 4.9161268,19.7980653 C5.30569232,22.8098117 7.87872506,25.1375022 10.9990498,25.1375022 C14.1174743,25.1375022 16.6924074,22.8098117 17.0838732,19.7980653 C17.1180789,19.5358438 17.1370821,19.2698221 17.1370821,19 C17.1370821,18.7301779 17.1180789,18.4641562 17.0838732,18.2038349 L20.4056319,18.2038349 L20.4056319,16.6742097 C20.4056319,16.4537917 20.4949469,16.2561755 20.6393712,16.1117637 C20.7837955,15.9673519 20.983329,15.8780446 21.2018658,15.8780446 Z"
                        id="icon/paparrazi-logo"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <h5>Paparazzi</h5>
            </div>
          </div>
        </a>
      </div>

      <div className="col-xs-12 col-sm-6 col-md-3">
        <a
          className="app-link"
          href="/programmatic_banners"
          title="SPAM"
          target="_blank"
          onClick={() => mixpanel.track('SPAM Link Clicked')}
        >
          <div className="card darkbg">
            <div className="card-top">
              <div className="circle blueberry-dark">
                <SettingsEthernetIcon className="material-icons" />
              </div>
              <h5>Enhanced Ads Preview Tool</h5>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default LinkList;
